import { readFile } from 'fs/promises';
import HttpBrowser from './Http.js';
import { Aci, CompileResult } from './Base.js';
import { Encoded } from '../../utils/encoder.js';
import getFileSystem from './getFileSystem.js';

/**
 * Contract Compiler over HTTP for Nodejs
 *
 * Inherits CompilerHttp and implements `compile`, `validate` methods
 * @category contract
 * @example CompilerHttpNode('COMPILER_URL')
 */
export default class CompilerHttpNode extends HttpBrowser {
  override async compile(path: string): CompileResult {
    const fileSystem = await getFileSystem(path);
    const sourceCode = await readFile(path, 'utf8');
    return this.compileBySourceCode(sourceCode, fileSystem);
  }

  override async generateAci(path: string): Promise<Aci> {
    const fileSystem = await getFileSystem(path);
    const sourceCode = await readFile(path, 'utf8');
    return this.generateAciBySourceCode(sourceCode, fileSystem);
  }

  override async validate(bytecode: Encoded.ContractBytearray, path: string): Promise<boolean> {
    const fileSystem = await getFileSystem(path);
    const sourceCode = await readFile(path, 'utf8');
    return this.validateBySourceCode(bytecode, sourceCode, fileSystem);
  }
}
